import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import List from './list';

class Headline extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        data: this.props.content,
    };

    /**
     * 渲染组件
     */
    render() {
        const { data } = this.state;

        return (
            <div className={styles.box}>
                <Chip
                    id="20003"
                    type="recommend"
                    title="头条新闻"
                    groupName="正文"
                    content={data}
                    position="relative"
                    translate="handleHeadlinePicData">
                    <List />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(Headline);
